<template>
	<Page animate>
		<template v-slot:content>
			<SafeAreaTop @close="onClose" closePosition="left" :theme="close_theme">
				<div class="container">
					<div class="title">
						<i18n-t keypath="title">
							<span class="color-purple">{{ t('new_you') }}</span>
						</i18n-t>
					</div>
					<!-- <div class="title">Get <span class="color-purple">New You in 2022</span> with a Simple Premium</div> -->

					<div class="promo">
						<img :src="require(`@/assets/paywall/ny2022-promo/${language}.svg`)" alt="" />
					</div>

					<Products :products="products" :active="active_product" @select="handleSelect" theme="ny2022" />

					<div class="links">
						<a @click.prevent="terms" href="">{{ t('terms') }}</a>
						<span></span>
						<a @click.prevent="privacy" href="">{{ t('privacy') }}</a>
						<span></span>
						<a @click.prevent="handleRestore" href="">{{ t('restore') }}</a>
					</div>
				</div>
			</SafeAreaTop>

			<Alert
				:isOpen="showRestoreSuccessAlert"
				:title="t('restore_popup.success.title')"
				:text="t('restore_popup.success.body')"
				@onClose="onCloseRestoreSuccessAlert"
			/>
			<Alert
				:isOpen="showRestoreErrorAlert"
				:title="t('restore_popup.error.title')"
				:text="t('restore_popup.error.body')"
				@onClose="onCloseRestoreErrorAlert"
			/>

			<Prompt
				:isOpen="showPaywallCancelPrompt"
				:title="t('cancel_popup.title')"
				:text="t('cancel_popup.body', { store: platform == 'ios' ? 'iTunes Store' : 'Play Store' })"
				:action="t('cancel_popup.action')"
				@onClose="onClosePaywallCancelPrompt"
				@onAction="onActionPaywallCancelPrompt"
			/>
		</template>

		<template v-slot:footer>
			<div class="container">
				<p-button @click.prevent="handleSubmit" label="" :loading="isLoading" cls="btn-primary btn-block">
					{{ t('product.unlock_new_you') }}
				</p-button>
			</div>
		</template>
	</Page>
</template>

<script>
import Page from '@/components/Page'
import Alert from '@/components/Alert'
import Prompt from '@/components/Prompt'
import PButton from '@/components/Button'
import Products from '@/components/products/ios/Products'
import { computed, ref } from '@vue/reactivity'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

import useApi from '@/composition/api.js'
import useConfig from '@/composition/config.js'
import SafeAreaTop from '@/components/SafeAreaTop.vue'
import { inject, watch } from '@vue/runtime-core'

export default {
	components: {
		Page,

		Products,
		SafeAreaTop,
		PButton,
		Alert,
		Prompt
	},

	setup() {
		try {
			const { t, locale } = useI18n({
				useScope: 'global',
				messages: {
					en: {
						new_you: 'the new you',
						title: 'Kick-start {0} in 2022 with Simple Premium',
						product: {
							you_personal_plan: 'Your personal price',
							monthly_plan: 'Regular monthly price',
							original: 'FULL PRICE',
							unlock_new_you: 'UNLOCK THE NEW YOU'
						}
					},
					de: {
						new_you: 'neuen Ich',
						title: 'Werde 2022 zu deinem {0} mit Simple Premium',
						product: {
							you_personal_plan: 'Persönlicher Plan',
							monthly_plan: 'Monatlicher Plan',
							original: 'URSPRÜNGLICHER PREIS',

							unlock_new_you: 'WERDE ZU DEINEM NEUEN ICH'
						}
					},
					es: {
						new_you: 'tu mejor versión en el 2022',
						title: 'Consigue {0} con Simple Prémium',
						product: {
							you_personal_plan: 'Plan personalizado',
							monthly_plan: 'Plan mensual',
							original: 'ORIGINAL',

							unlock_new_you: 'Descubre tu mejor versión'
						}
					},
					fr: {
						new_you: 'Un nouveau vous en 2022',
						title: '{0} grâce à Simple Premium',
						product: {
							you_personal_plan: 'Votre forfait personnel',
							monthly_plan: 'Forfait mensuel',
							original: 'ORIGINEL',

							unlock_new_you: 'REDÉCOUVREZ-VOUS !'
						}
					},
					it: {
						new_you: 'Una nuova versione di te nel 2022',
						title: 'Trasformati in {0} con Simple Premium',
						product: {
							you_personal_plan: 'Il tuo piano personalizzato',
							monthly_plan: 'Piano mensile',
							original: 'ORIGINALE',

							unlock_new_you: 'SBLOCCA LA MIGLIORE VERSIONE DI TE'
						}
					},
					pt: {
						new_you: 'Um novo você em 2022',
						title: 'Surpreenda-se com {0} adquirindo o Simple Premium',
						product: {
							you_personal_plan: 'Seu plano personalizado',
							monthly_plan: 'Plano mensal',
							original: 'ORIGINAL',

							unlock_new_you: 'SURPREENDA-SE COM UM NOVO VOCÊ'
						}
					},
					ru: {
						new_you: 'лучшей версией себя в 2022',
						title: 'Станьте {0} с Simple Premium',
						product: {
							you_personal_plan: 'Ваш персональный план',
							monthly_plan: 'Месячная подписка',
							original: 'ИЗНАЧАЛЬНО',

							unlock_new_you: 'ВПЕРЕД К НОВЫМ ЦЕЛЯМ'
						}
					}
				}
			})
			const language = computed(() => locale.value)

			const amplitude = inject('amplitude')
			const store = useStore()
			const api = useApi()
			const config = useConfig()
			const router = useRouter()
			const platform = api.getPlatform()

			const { terms, privacy } = api

			const products = computed(() => {
				const config_top_product = config.get({ key: 'paywall.top_product', default_value: {} })
				const top_product = Object.assign(
					{
						id: 'simple_sale_subscription_12_months_63off_no_trial',
						text: t('product.you_personal_plan'),
						subtitle: t('product.annyally_title'),
						badge: t('product.badge', { count: 92 }),
						terms: t('product.annyally_terms')
					},
					config_top_product
				)

				const config_bottom_product = config.get({ key: 'paywall.bottom_product', default_value: {} })
				const bottom_product = Object.assign(
					{
						id: 'simple_original_subscription_1_month',
						text: t('product.monthly_plan'),
						subtitle: t('product.price_per_month'),
						badge: t('product.original'),
						terms: t('product.monthly_terms')
					},
					config_bottom_product
				)

				const obj = {
					top_product,
					bottom_product
				}
				return store.getters['products/getData'](Object.values(obj))
			})

			let active_product = ref(products.value[0])
			watch(products, () => {
				active_product.value = products.value[0]
			})

			const close = (Status = 'Close', NextRoute = null) => {
				amplitude.logEvent('Paywall - Close', {
					Layout: config.get({ key: 'layout', default_value: 'New Year - 2022' }),
					From: store.getters['getSource'],
					Step: 'Paywall',
					Status
				})
				router.push({
					name: NextRoute || next.value
				})
			}

			let isLoading = computed(() => store.state.isLoading)
			let showRestoreSuccessAlert = ref(false)
			let showRestoreErrorAlert = ref(false)
			let showPaywallCancelPrompt = ref(false)
			let offerPopupId = ref(null)
			const next = computed(() => config.get({ key: 'postPaid.type', default_value: 'workbooks-bundle' }))
			const close_theme = computed(() => config.get({ key: 'paywall.close_buttom.theme', default_value: 'dark' }))

			const onClose = () => close()

			const Purchase = (product) => {
				api.purchase({
					productId: product.id,
					onFinish: () => {
						amplitude.logEvent('Paywall - Done', {
							Layout: config.get({ key: 'layout', default_value: 'New Year - 2022' }),
							From: store.getters['getSource'],
							Step: 'Paywall',
							ProductId: product.id,
							Status: 'Subscribe'
						})
						close('Subscribe')
					},
					onError: () => {
						console.log('error')
					},
					onCancel: () => {
						if (product.products_after_cancel && config.get({ key: 'after_cancel_show', default_value: false })) {
							offerPopupId.value = product.id
						} else {
							showPaywallCancelPrompt.value = true
						}
					},
					closeOnSuccess: false
				})
			}

			const handleSelect = (product) => {
				active_product.value = product
			}

			const handleRestore = () => {
				api.restore({
					closeOnSuccess: false,
					onFinish: () => {
						showRestoreSuccessAlert.value = true
					},
					onFail: () => {
						showRestoreErrorAlert.value = true
					}
				})
			}

			const onCloseRestoreSuccessAlert = () => {
				showRestoreErrorAlert.value = false
				close('Restore')
			}

			const onCloseRestoreErrorAlert = () => {
				showRestoreErrorAlert.value = false
			}

			const onClosePaywallCancelPrompt = () => {
				showPaywallCancelPrompt.value = false
			}

			const onActionPaywallCancelPrompt = () => {
				showPaywallCancelPrompt.value = false
				Purchase(active_product.value)
			}

			const handleSubmit = () => {
				Purchase(active_product.value)
			}

			return {
				t,
				products,
				active_product,
				isLoading,
				handleSelect,
				handleSubmit,
				handleRestore,
				terms,
				privacy,
				showRestoreSuccessAlert,
				showRestoreErrorAlert,
				showPaywallCancelPrompt,
				onCloseRestoreSuccessAlert,
				onCloseRestoreErrorAlert,
				onClosePaywallCancelPrompt,
				onActionPaywallCancelPrompt,
				onClose,
				close_theme,
				platform,
				language
			}
		} catch (e) {
			document.getElementById('log').innerHTML = e
		}
	}
}
</script>

<style scoped lang="scss">
.title {
	font-weight: bold;
	font-size: 1.8rem;
	text-align: center;
	padding-top: 3.5rem;
	line-height: 1.2;
	max-width: 90%;
	margin-left: auto;
	margin-right: auto;
}

.color-purple {
	color: #e46a8a;
}

.promo {
	margin-top: -2rem;
}

.links {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 1.4rem;
	flex-wrap: wrap;

	span {
		width: 3px;
		height: 3px;
		border-radius: 50%;
		background-color: #3b3c57;
		margin: 2px 12px;
		opacity: 0.5;
	}

	a {
		text-decoration: none;
		color: #3b3c57;
		font-size: 0.9rem;
		display: block;
		margin: 2px 0;
	}
}

.absolute {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 2;
	width: 100%;
}
</style>
